import Abstract from "../../abstract-view/abstract.js";

export default class TabsList extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._parentElement = null;

    this._touchStartHandler = this._touchStartHandler.bind(this);
    this._touchEndHandler = this._touchEndHandler.bind(this);
  }

  getLinks() {
    return this._element.querySelectorAll(`a`);
  }

  getParent() {
    if (!this._parentElement) {
      this._parentElement = this._element.parentElement;
    }

    return this._parentElement;
  }

  addSliderClass() {
    this._element.classList.add(`${this._element.classList[0]}_slider`);
  }

  removeSliderClass() {
    this._element.classList.remove(`${this._element.classList[0]}_slider`);
  }

  translate(value) {
    this._element.style.transform = `translateX(-${value}px)`;
  }

  setTouchStartHandler(callback) {
    this._callback.touchStart = callback;
    this._element.addEventListener(`touchstart`, this._touchStartHandler);
  }

  setTouchEndHandler(callback) {
    this._callback.touchEnd = callback;
    this._element.addEventListener(`touchend`, this._touchEndHandler);
  }

  removeTouchStartHandler() {
    this._callback.touchStart = null;
    this._element.removeEventListener(`touchstart`, this._touchStartHandler);
  }

  removeTouchEndHandler() {
    this._callback.touchEnd = null;
    this._element.removeEventListener(`touchend`, this._touchEndHandler);
  }

  _touchStartHandler(evt) {
    this._callback.touchStart(evt);
  }

  _touchEndHandler(evt) {
    this._callback.touchEnd(evt);
  }
}
